import React from 'react';
import { connect } from 'react-redux';
import Modal from '../../../../layout/modal/Modal';
import ClientsForm from '../../Forms/ClientsForm';
import { getFormItems } from '../../../../../redux/forms/actions';
const FormModal = ({
	// parent props
	formId,
	showModal,
	leadId,
	isEditClientForms,
	closeFormModal,
	// redux
	getFormItems,
	coBrokerData,
	lawyerData,
	mortgageData,
}) => {
	const [error, setError] = React.useState();
	const [formData, setFormData] = React.useState(
		formId === 'cobroker'
			? coBrokerData
			: formId === 'lawyer'
			? lawyerData
			: formId === 'mortgage'
			? mortgageData
			: ''
	);

	React.useEffect(() => {
		getFormItems('purchasers', 'clientDetails');
	}, [formId]);
	return (
		<Modal
			show={showModal}
			close={() => {
				setError();
				setFormData();
				closeFormModal(leadId);
			}}
			wrapperWidth='90%'
			wrapperMax={830}
		>
			<ClientsForm
				formId={formId}
				leadId={leadId}
				isEditClientForms={isEditClientForms}
				show={showModal}
				closeFormModal={closeFormModal}
				error={error}
				setError={setError}
				formData={formData}
				setFormData={setFormData}
			/>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	coBrokerData:
		state.agreement.agreementById?.cobroker ||
		state.forms.form.clientDetails?.cobroker?.formData,
	lawyerData:
		state.agreement.agreementById?.lawyer ||
		state.forms.form.clientDetails?.lawyer?.formData,
	mortgageData:
		state.agreement.agreementById?.mortgage ||
		state.forms.form.clientDetails?.mortgage?.formData,
});

export default connect(mapStateToProps, { getFormItems })(FormModal);
